import React from 'react';

export const AuthLayout = ({ children }) => (
    <main className="auth-minimal-wrapper">
        <div className="auth-minimal-inner">
            <div className="minimal-card-wrapper">
                {children}
            </div>
        </div>
    </main>
);
